import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { googleViewerFiles, imageTypes } from 'src/app/shared/constants';
import { ContactHttpService } from '../../services/contact.http.service';
import { identifierName } from '@angular/compiler';

@Component({
  selector: 'app-shared-file-opener',
  templateUrl: './file-opener.component.html',
  styleUrls: ['./file-opener.component.scss']
})
export class FileOpnerComponent implements OnInit {
  @Input() modalDisplay: boolean = false;
  @Input() modalFile: any;
  @Input() directLink: boolean = false;
  @Output() closeFilePreview = new EventEmitter();

  modalHeader: string = "";
  displayImagePreview: boolean = false;
  currentFileLink: string = "";
  currentViewer: string = "";
  imageWidth: string;
  downloadLink:string;
  constructor(
    private contactHttpService:ContactHttpService
  ) {}

  ngOnInit() {
    // let id = this.modalFile?.id ? this.modalFile?.id : this.modalFile?.attachmentId
    if(this.directLink){
        this.downloadLink = this.modalFile.downloadLink;
        this.initializeData();
    }else{
        this.getDownloadLink(this.modalFile?.id);
    }
  }

  initializeData() {
    const extension = this.modalFile?.extension?.toLowerCase();
    this.modalHeader = "Preview " + this.getFileTypeName(extension);
    this.displayImagePreview = imageTypes.includes(extension);
    this.displayImagePreview && this.setImageHeightWidth();
    this.currentFileLink = this.downloadLink;
    this.currentViewer = this.getCurrentViewer(extension);
  }

  getDownloadLink(id:number){
    let requestBody:{
      id:number;
      isDefaultContentType :boolean
    } = {
      id:id,
      isDefaultContentType :false
    }
    this.contactHttpService.downloadFilesAndFolder(requestBody).subscribe({
      next:(data)=>{
        this.downloadLink = data?.downloadLink;
        this.initializeData();
      }
    })
  }




  getFileTypeName(extension: string): string {
    let typeName = '';

    if (imageTypes.includes(extension)) {
      typeName = 'Image';
    } else if (['txt', 'doc', 'docx'].includes(extension)) {
      typeName = 'Document';
    } else if (['xls', 'xlsx', 'csv'].includes(extension)) {
      typeName = 'Sheet';
    } else if (['ppt', 'pptx'].includes(extension)) {
      typeName = 'Slide';
    } else {
      typeName = 'PDF';
    }

    return typeName;
  }

  getCurrentViewer(extension: string): string {
    let currentViewer: string = "";

    if (googleViewerFiles.includes(extension)) {
      currentViewer = 'google';
    } else {
      currentViewer = 'office';
    }

    return currentViewer;
  }

  setImageHeightWidth() {
    const img: HTMLImageElement = document.querySelector('img');
    this.imageWidth = Math.min(img.naturalWidth, 500) + 'px';
  }

  hideModal(): void {
    this.closeFilePreview.emit();
  }
}
